import React from 'react'
import styles from './SparkleLine.module.css'
const SparkleLine = () => {
    return (
        <>
            <div className={styles.sparkleLineMAin}>
                <div className={styles.sparkleWrapper}>
                    <div className={styles.sparkleLine}></div>

                    <span className={styles.sparkle}>
                        <img src="/svg/spark_svg.svg" alt="spark_svg" />
                    </span>
                </div>
            </div>


        </>
    )
}

export default SparkleLine
